import { render, staticRenderFns } from "./Alone.vue?vue&type=template&id=6cd603e6&scoped=true"
import script from "./Alone.vue?vue&type=script&lang=js"
export * from "./Alone.vue?vue&type=script&lang=js"
import style0 from "./Alone.vue?vue&type=style&index=0&id=6cd603e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd603e6",
  null
  
)

export default component.exports